module.exports = __webpack_public_path__ + "static/media/sort-shapes-down-alt.8343bab7.svg";